import type { LoaderFunctionArgs } from 'react-router';

import { setLanguageFromUrl } from '@/utils/language';

export async function rootLoader({ request }: LoaderFunctionArgs) {
  setLanguageFromUrl(request);
  return null;
}
